// import moment from 'moment';
// Utils
import { getSessionStorageItem } from 'utils';
import { mutateFilters } from 'utils/salesOrder';
// App Actions
import { addNotification } from 'context/AppContext/actions';
// Actions
import * as salesActions from 'context/SalesOrderContext/actions';
// Flags
import * as salesConstants from 'context/SalesOrderContext/statusFlags';
// Services
import { getSalesOrders } from 'services/salesOrderV1/salesOrders';
// Types
import { APIResponseProps } from 'types/global';
import { supplierIdMapping } from 'pages/SalesOrder/config/index';
import { SalesOrderProps } from 'types/salesOrder';
import * as types from './types';


function filteredSupplierEvent(event: SalesOrderProps) {
  let test = false;
  const org = getSessionStorageItem({ item: 'defaultOrganisation' }).orgDescription;
  for (const [key, items] of Object.entries(supplierIdMapping)) {
    if (org === key) {
      test = items.includes(event.orderInfo.supplierId)
    }
  }
  return test;
}

export async function getEvents({
  appDispatch,
  salesOrderDispatch,
  filters,
  orgRef,
}: types.GetSalesOrderProps) {
  salesOrderDispatch(salesActions.setSalesOrderState(salesConstants.GET_SALES_ORDER));
  const { errorMessage, response }: APIResponseProps = await getSalesOrders({
    reqParams: mutateFilters(filters),
  });
  if (response) {
    const { salesOrders, metadata } = response;
    const filteredSalesOrders = salesOrders.filter(filteredSupplierEvent);
    if (filters.offSet === 0) {
      salesOrderDispatch(salesActions.setSalesOrder(filteredSalesOrders));
    } else {
      salesOrderDispatch(salesActions.appendSalesOrder(filteredSalesOrders));
    }

    // Call next offset if no fildered order found
    if (filteredSalesOrders.length === 0 && metadata.links.next !== null) {
      salesOrderDispatch(salesActions.setSalesOrderFilters({ ...filters, offSet: filters.offSet + 10 }));
    }

    // Update no more event
    salesOrderDispatch(salesActions.setNoMoreSalesOrder(metadata.links.next !== null))
    salesOrderDispatch(salesActions.setSalesOrderState(salesConstants.GET_SALES_ORDER_SUCCESS));
  }
  if (errorMessage) {
    salesOrderDispatch(salesActions.setSalesOrderState(salesConstants.GET_SALES_ORDER_ERROR));
    salesOrderDispatch(salesActions.setNoMoreSalesOrder(false));
    if (filters.offSet > 0) {
      appDispatch(addNotification({
        label: 'Some error has occured. Unable to retireve data from system',
        type: 'success',
      }))
    }
  }
}
